// components/landing/BackToTop.js
import { useState, useEffect } from 'react';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <button
        onClick={scrollToTop}
        aria-label="Voltar ao topo"
        className={`
          fixed bottom-8 right-8 z-50
          w-12 h-12 rounded-2xl
          bg-gray-900 text-white
          flex items-center justify-center
          shadow-[0_8px_24px_rgba(0,0,0,0.25)]
          hover:bg-black hover:shadow-[0_12px_32px_rgba(0,0,0,0.35)]
          hover:-translate-y-1
          transition-all duration-300 ease-out
          ${isVisible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'}
        `}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
        </svg>
      </button>
    </>
  );
};

export default BackToTop;